import { render, staticRenderFns } from "./ContactNotificationPreferences.vue?vue&type=template&id=06454d95&scoped=true&"
import script from "./ContactNotificationPreferences.vue?vue&type=script&lang=js&"
export * from "./ContactNotificationPreferences.vue?vue&type=script&lang=js&"
import style0 from "./ContactNotificationPreferences.vue?vue&type=style&index=0&id=06454d95&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06454d95",
  null
  
)

export default component.exports